import 'angular:locale/data:ru';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "ru";
